import __request__ from "routing/request";
export function aiClusterConfig(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp.investigations/ai/config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function disableAI(requestOptions) {
  return __request__("DELETE", "/plugins/org.graylog.plugins.securityapp.investigations/ai/config/ai_enabled", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function enableAI(requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp.investigations/ai/config/ai_enabled", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
